import { render, staticRenderFns } from "./DepositMonthlyChart.vue?vue&type=template&id=8e898434&"
import script from "./DepositMonthlyChart.vue?vue&type=script&lang=js&"
export * from "./DepositMonthlyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports